import React from 'react';

import { useIntl } from 'react-intl';

import { useFlags } from '@atlaskit/flag/use-flags';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';
import {
	migrationPublishMessages,
	MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM,
} from '@atlassian/company-hub-common/migration-publish-success';

interface MigrationPublishSuccessFlagProps {
	shouldShow?: boolean;
}

export const MigrationPublishSuccessFlag = ({
	shouldShow,
}: MigrationPublishSuccessFlagProps): null => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlags();

	React.useEffect(() => {
		const currentUrl = new URL(window.location.href);
		const shouldShowPublishSuccessFlag =
			shouldShow ?? currentUrl.searchParams.get(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM) === 'true';
		if (!shouldShowPublishSuccessFlag) {
			return;
		}

		if (shouldShow === undefined) {
			currentUrl.searchParams.delete(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM);
			window.history.replaceState(window.history.state, '', currentUrl);
		}

		const title = formatMessage(migrationPublishMessages.helpCenterPublished);
		showFlag({
			title,
			description: formatMessage(migrationPublishMessages.helpCenterPublishedDescription),
			isAutoDismiss: true,
			icon: (
				<StatusSuccessIcon label={title} color={token('color.icon.success')} spacing="spacious" />
			),
		});
	}, [formatMessage, shouldShow, showFlag]);

	return null;
};
